import React, { useEffect, useState } from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";
const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const scaleFade = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
};

const imageZoom = {
  hidden: { scale: 1.05, opacity: 0 },
  visible: { scale: 1, opacity: 1 },
};

const slideLeftToRight = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0 },
};

const slideRightT0Left = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
};

const NaturallyVentilatedPolyhouse = () => {
  const data = [
    {
      feature: "Height of Structure",
      kryzen: "6.8M to 7.2M from Ground Level",
      others: "6.2M to 6.5M from Ground Level",
    },
    {
      feature: "Side Ventilation",
      kryzen: "4 meters",
      others: "2.5 meters",
    },
    {
      feature: "Top Vent",
      kryzen: "1.2 to 1.4 meters",
      others: "2.5 meters",
    },
    {
      feature: "Pipe Quality and Galvanization",
      kryzen: "375 GSM to 400 GSM",
      others: "150 GSM to 250 GSM",
    },
    {
      feature: "Nut Bolts and Connectors",
      kryzen: "22 Micron Zinc Ferrous Coated",
      others:
        "Main Connectors are 5mm Coated (Zinc Coating). No Coating / 2mm Coating. Results in rusting in 6 months.",
    },
    {
      feature: "Foundation",
      kryzen:
        "76mm Diameter, 2mm Thickness. Crimped Foundation gives more strength.",
      others:
        "63mm Diameter, 1.6mm Thickness. Point Load Foundation is less stable.",
    },
    {
      feature: "Door",
      kryzen: "Aluminium Double Sliding Door with Buffer Zone",
      others: "Basic Non-Sliding GI Door without buffer zone",
    },
    {
      feature: "End Gutters",
      kryzen: "Yes, at both ends of the structure",
      others: "N/A",
    },
    {
      feature: "Shade Net and Mechanism",
      kryzen:
        "Pulley System Hybrid Mechanism with sandwich clips. PVC wire used.",
      others:
        "Hook Mechanism. Hook tears net in 1 year. GI wire rusts and tears net.",
    },
    {
      feature: "Reinforcement and Anti-Wind Breakers",
      kryzen: "Multiple reinforcements and wind breakers provided",
      others: "No reinforcements given",
    },
    {
      feature: "Hockey Pipe",
      kryzen: "Square Pipes provide more stability",
      others: "Round Pipes — less stability",
    },
    {
      feature: "Tonnage of Structure",
      kryzen: "20–21 Tonnes Steel (24 tonnes approx.)",
      others: "16 Tonnes Steel (19 tonnes approx.)",
    },
    {
      feature: "Profile",
      kryzen:
        "Aluminium Profile – prevents heat transfer, increases plastic life",
      others: "GI Profile – heats and damages plastic",
    },
    {
      feature: "Spring",
      kryzen: "PVC-Coated Springs – don’t heat the plastic",
      others: "GI spring – heats and damages plastic",
    },
    {
      feature: "Polyfilm",
      kryzen: "7 Layer Anti-dust, anti-drip, high tensile strength",
      others: "Local",
    },
    {
      feature: "Shade/Insect Net",
      kryzen: "Kryzen Make with Extended Warranty",
      others: "Local",
    },
    {
      feature: "Multiple Designed Connectors",
      kryzen: "Israeli-designed connectors for better strength",
      others: "Local connectors",
    },
    {
      feature: "Other Features",
      kryzen:
        "Curtain Box System (Optional), FLC Mechanism (Optional), Aluminet Shade Net by Ginegar (5 years warranty)",
      others: "No genuine Aluminet",
    },
    {
      feature: "Agronomist Support",
      kryzen: "6 months Free Agronomist Support",
      others: "No Support",
    },
  ];

  return (
    <>
      <SEO
        title="Kryzen Polyhouse / Greenhouse | Controlled Environment Farming"
        description="Explore Kryzen Polyhouse and Greenhouse systems — advanced protected farming structures using polyethylene sheets that enable year-round crop production with optimal temperature, humidity, and light control."
        keywords="polyhouse farming, greenhouse farming India, kryzen polyhouse, controlled environment agriculture, polyhouse structure, protected cultivation, greenhouse vegetables, greenhouse temperature control"
        canonical="https://alpha.kryzen.com/kryzen-naturally-ventilated-polyhouse"
        ogTitle="Kryzen Polyhouse / Greenhouse"
        ogDescription="Kryzen Polyhouse and Greenhouse structures provide a regulated farming environment for vegetables, fruits, flowers, and herbs. Enhance your yield with our advanced farming solutions."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752134261/2_oy0kto.jpg"
        twitterTitle="Kryzen Polyhouse / Greenhouse | Controlled Environment Farming"
        twitterDescription="Explore Kryzen Polyhouse and Greenhouse systems — advanced protected farming structures using polyethylene sheets that enable year-round crop production with optimal temperature, humidity, and light control."
      />
      {/* Slider Section */}

      <Slider
        heding={"Naturally Ventilated Polyhouse"}
        paragraph={`A polyhouse is a type of greenhouse structure made from transparent
            or translucent polyethylene sheets that create a controlled
            environment for plant growth. This protective covering helps
            regulate temperature, humidity, and light, providing optimal growing
            conditions for various crops
           including vegetables, fruits, flowers, and herbs`}
      />

      {/* Intro Heading */}

      {/* Content Section */}
      <div className="container mainDiv py-5">
        <div className="text-center py-5 px-3">
          <motion.h1
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.7 }}
            className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
          >
            Kryzen Polyhouse / Greenhouse
          </motion.h1>

          <hr></hr>
          <motion.p
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lead mx-auto p-5"
            style={{ lineHeight: "1.8", fontSize: "25px" }}
          >
            A polyhouse is a type of greenhouse structure made from transparent
            or translucent polyethylene sheets that create a controlled
            environment for plant growth. This protective covering helps
            regulate temperature, humidity, and light, providing optimal growing
            conditions for various crops, including vegetables, fruits, flowers,
            and herbs.
          </motion.p>
        </div>
        <div className="row g-5 align-items-stretch mb-5">
          <div className="col-md-6">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={scaleFade}
              transition={{ duration: 0.5 }}
            >
              <motion.img
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={imageZoom}
                transition={{ duration: 0.6 }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752134261/2_oy0kto.jpg"
                alt="What is a Polyhouse?"
                className="card-img-top img-fluid"
                style={{ maxHeight: "350px", objectFit: "cover" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Polyhouse
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  A polyhouse is typically covered with polyethylene sheets
                  (plastic), which are durable and cost-effective. These
                  structures are designed to create a controlled environment by
                  regulating light, temperature, and humidity. Generally more
                  affordable due to the use of plastic sheets for covering.
                  Polyhouses are an economical option for small and medium-scale
                  farmers looking for a controlled farming environment. A
                  polyhouse provides good temperature control but is generally
                  less effective in very extreme weather conditions compared to
                  glass greenhouses. Polyethylene sheets in polyhouses allow
                  diffused light to pass through, which is beneficial for
                  uniform plant growth. However, they may not provide as much
                  clarity or light intensity as glass.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-6">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={scaleFade}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752145905/kryzen-page-2_gqnvlf.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid"
                style={{ maxHeight: "350px", objectFit: "cover" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Greenhouse
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  A greenhouse can be covered with a variety of materials, such
                  as glass, polycarbonate panels, or polyethylene. Greenhouses
                  made with glass are often more durable but also more expensive
                  compared to polyhouses. More expensive, especially if using
                  glass or polycarbonate. Glass greenhouses are more common in
                  larger commercial farms where long-term investment is
                  feasible. Offers superior insulation and temperature control,
                  particularly when built with high-quality materials like glass
                  or polycarbonate. It maintains stable temperatures, making it
                  suitable for a wider range of crops and climates. Glass or
                  polycarbonate greenhouses allow maximum light transmission,
                  offering the best possible conditions for crops that need high
                  levels of sunlight.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
        <div
          className="mt-7 py-5"
          style={{
            background:
              "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
            color: "black",
            border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
            padding: "1rem",
            borderRadius: "0.25rem",
          }}
        >
          <div className="row">
            <div className="col-12">
              <h3 className="text-success fw-bold mb-4">
                Technical Specifications
              </h3>
              <div className="table-responsive">
                <table className="table table-bordered align-middle">
                  <tbody>
                    <tr>
                      <th scope="row">Wind Load</th>
                      <td>0.5 KN/m²</td>
                    </tr>
                    <tr>
                      <th scope="row">Snow Load</th>
                      <td>0.35 KN/m²</td>
                    </tr>
                    <tr>
                      <th scope="row">Maximum Drainage Capacity</th>
                      <td>140 mm/h</td>
                    </tr>
                    <tr>
                      <th scope="row">Span Width</th>
                      <td>4m, 8m, 9.6m, 10.8m, 12.8m or customized</td>
                    </tr>
                    <tr>
                      <th scope="row">Column Spacing</th>
                      <td>4.0m, 8.0m or customized</td>
                    </tr>
                    <tr>
                      <th scope="row">Shoulder Height</th>
                      <td>3.0m – 6.0m or customized</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-12 mt-5">
              <h3 className="text-success fw-bold mb-4">
                Why Use a Polyhouse?
              </h3>
              <p
                style={{
                  fontSize: "1.05rem",
                  lineHeight: "1.8",
                  color: "#444",
                }}
              >
                One of the biggest advantages of a polyhouse is that it allows
                farmers to extend growing seasons, enabling off-season
                production of high-quality crops. This controlled environment
                helps improve crop yield, conserve water, and increase overall
                productivity—making polyhouses a valuable investment for modern
                agricultural practices.
                <br />
                <br />
                Whether for small-scale or large-scale farming operations,
                polyhouses are a reliable solution for boosting both quality and
                quantity in crop cultivation.
              </p>
            </div>
          </div>
        </div>
        <div className="row g-5 align-items-stretch mt-7">
          {/* Left Column */}
          <div className="col-md-4">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideLeftToRight}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <motion.img
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={imageZoom}
                transition={{ duration: 0.6 }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147218/mainframe_totggg.jpg"
                alt="What is a Polyhouse?"
                className="card-img-top img-fluid"
                style={{ width: "100%", height: "300px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Main Frame Material
                </h5>
                <motion.p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={fadeUp}
                  transition={{ duration: 0.6, delay: 0.2 }}
                >
                  Constructed from high-quality hot-dip galvanized steel, our
                  structure boasts a Zinc-coating of 275g/m2, ensuring a robust
                  service life of over 20 years. The steel components are
                  assembled on-site without needing secondary processing.
                  Galvanized connectors and fasteners are designed to resist
                  rust for two decades, guaranteeing long-term durability and
                  reliability.
                </motion.p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-4">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={scaleFade}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <motion.img
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={imageZoom}
                transition={{ duration: 0.6 }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147339/out_ddbqic.webp"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "300px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Covering Materials
                </h5>
                <motion.p
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={fadeUp}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  Our covering materials made up of LDPE, mLLDPE, EVA, EBA with
                  a tensile strength of 25 MPa offer excellent light
                  transmission, superior heat preservation, and strong tensile
                  strength. They provide economical rain, wind & sun protection
                  to plants, with a lifespan of 5-7 years, ensuring
                  cost-effectiveness without compromising on quality.
                </motion.p>
              </div>
            </motion.div>
          </div>

          {/* Right Column */}
          <div className="col-md-4">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideRightT0Left}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <motion.img
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={imageZoom}
                transition={{ duration: 0.6 }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147630/nvph_knv1je.webp"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "300px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Outside Shading System
                </h5>
                <motion.p
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={fadeUp}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  Engineered to provide optimal cooling and shading during the
                  summer, this system diffuses sunlight within the greenhouse,
                  effectively shielding crops from harmful sun glare and
                  ensuring consistent growth conditions. Shading systems are
                  utilized widely when you want to grow crops which are locally
                  climatically affected.
                </motion.p>
              </div>
            </motion.div>
          </div>
        </div>
        <h1 className="display-6 fw-bold text-uppercase text-center mb-2 mt-7">
          3 Mechanism to control climate in polyhouse
        </h1>
        <hr></hr>{" "}
        <div className="row g-5 align-items-stretch mt-7">
          {/* Left Column */}
          <div className="col-md-4">
            <motion.div
              className="card border-0 h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideLeftToRight}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752148188/bestair_pxyvhi.jpg"
                alt="What is a Polyhouse?"
                className="card-img-top img-fluid"
                style={{ width: "100%", height: "300px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  BEST AIR VENT DESIGN
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  Kryzen’s NVPH (Natural Ventilation Polyhouse) is designed with
                  advanced ventilation features to optimize airflow and
                  temperature control. It includes a 1.4m top vent for releasing
                  hot air and a 4.5m side vent for drawing in cool air. This
                  combination ensures efficient air circulation, helping to
                  maintain ideal growing conditions inside the polyhouse. These
                  ventilation systems regulate temperature naturally, creating a
                  balanced environment for healthier crop growth and higher
                  productivity.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-4">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={scaleFade}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752148188/fan_cstqxz.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  SS Air Circulation Fan
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  At a speed of 950 RPM, the airflow in your polyhouse reaches a
                  distance of ~22 metres, effectively breaking humidity pockets
                  with ease. The auto-controlled speed and on-off mechanism work
                  together to maintain the temperature at an optimum level,
                  ensuring a balanced environment for crop growth. This system,
                  combined with fogger operations, enhances air circulation and
                  prevents humidity buildup, promoting healthier plants,
                  reducing fungal infection and higher yields.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Right Column */}
          <div className="col-md-4">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideRightT0Left}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752148189/tall_q6pkjz.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "300px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  7.2 metre Tall Structure
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  In taller polyhouse structures, the **volume of CO2**
                  increases due to the larger air capacity. Higher CO2 levels
                  inside the structure lead to improved plant growth, as carbon
                  dioxide is essential for photosynthesis. With more CO2
                  available, plants can photosynthesize more efficiently,
                  resulting in healthier and faster growth. Therefore, taller
                  polyhouses not only enhance air circulation but also create an
                  environment rich in CO2, promoting better crop yields.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
        <div>
          <div
            className="container my-5 py-5"
            style={{
              background:
                "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
              color: "#000",
              border: "1px solid #c0e6b6",
              borderRadius: "8px",
              padding: "1rem",
            }}
          >
            <h3 className="text-success fw-bold mb-4">
              Optional Intelligent Polytunnel Add-ons
            </h3>

            <div className="table-responsive">
              <table className="table table-bordered table-striped align-middle">
                <thead className="table-success">
                  <tr>
                    <th style={{ width: "25%" }}>Add-on</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Steel Structure</th>
                    <td>Hot-galvanized steel pipe</td>
                  </tr>
                  <tr>
                    <th scope="row">Greenhouse Glass</th>
                    <td>Different models can be selected</td>
                  </tr>
                  <tr>
                    <th scope="row">Sun-shading Net</th>
                    <td>
                      Summer shade, block rain, moisture, cooling, winter/spring
                      heat preservation
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Cooling System</th>
                    <td>
                      The fan forms negative pressure and the water curtain
                      cools down
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Heating System</th>
                    <td>
                      Thermal insulation series, air heater, boiler and pipe
                      heating, air circulating fan
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Ventilation System</th>
                    <td>Side windows and cooling fans</td>
                  </tr>
                  <tr>
                    <th scope="row">
                      Water & Fertilizer Integrated Irrigation System
                    </th>
                    <td>
                      Sprinkler irrigation series, drip irrigation series,
                      intelligent mobile sprinkler irrigation
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Automatic Control System</th>
                    <td>
                      Automatic control technology that can independently drive
                      intelligent machines to achieve control objectives without
                      human intervention
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Fill-in Light</th>
                    <td>
                      Easy assemble auto light deprivation blackout greenhouse
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Seedling Bed</th>
                    <td>Movable seeding bed</td>
                  </tr>
                  <tr>
                    <th scope="row">Hydroponics</th>
                    <td>
                      It is reusable, requires no nutrient additions, and is
                      both convenient and inexpensive.
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">External & Internal Shading System</th>
                    <td>The gear rack drives the shading system</td>
                  </tr>
                  <tr>
                    <th scope="row">Photovoltaic System</th>
                    <td>For solar power generation</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="text-center py-5 px-3 mt-7">
          <motion.h1
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.7 }}
            className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
          >
            Optional Intelligent Polytunnel Add-ons
          </motion.h1>

          <hr></hr>
        </div>
        <div className="row g-5 align-items-stretch">
          {/* Left Column */}
          <div className="col-md-3">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideLeftToRight}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752149137/hot_deep_z3hels.jpg"
                alt="What is a Polyhouse?"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Hot DIP Galvanized Steel
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  The entire structure is made up of GI Steel, giving a very
                  high lifespan to construction as the whole.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-3">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideLeftToRight}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752149137/net_rdh638.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Fibre-threaded Insect net
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  Good quality insect net which lets air pass freely but
                  obstruct insects, rodents & birds from entering inside.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Right Column */}
          <div className="col-md-3">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideRightT0Left}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752149136/alunium_d8gnik.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  Aluminum / GI Accessories
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  All small to big accessories are made up of Aluminium or GI,
                  making sure the structure core has zero weak links.
                </p>
              </div>
            </motion.div>
          </div>
          <div className="col-md-3">
            <motion.div
              className="card border-0  h-100"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={slideRightT0Left}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752149137/layer_ibrkap.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  200M-7Layer Polyfilm
                </h5>
                <p
                  className="card-text text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                >
                  7 Layer Polyfilm ensures good quality and quantity of sunlight
                  (light wavelengths) reaches the plants.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="text-center py-5 px-3 mt-7">
          <motion.h1
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.7 }}
            className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
          >
            crop shading solution
          </motion.h1>

          <hr></hr>
        </div>
        <div className="row g-5 align-items-stretch">
          {/* Left Column */}
          <div className="col-md-4">
            <div
              className="card border-0 shadow-sm h-100"
              onMouseEnter={(e) => {
                e.currentTarget.classList.add("shadow-lg");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.classList.remove("shadow-lg");
              }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752206370/aluminet_fexoch.jpg"
                alt="What is a Polyhouse?"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  kryzen aluminet (heat repellent)
                </h5>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div
              className="card border-0 shadow-sm h-100"
              onMouseEnter={(e) => {
                e.currentTarget.classList.add("shadow-lg");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.classList.remove("shadow-lg");
              }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752206369/shadenet_uw5zjl.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  kryzen Shadenet (30% / 50% / 70%)
                </h5>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-4">
            <div
              className="card border-0 shadow-sm h-100"
              onMouseEnter={(e) => {
                e.currentTarget.classList.add("shadow-lg");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.classList.remove("shadow-lg");
              }}
            >
              <img
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752206369/insetnet_dyalyp.jpg"
                alt="Grrenhouse Benefits"
                className="card-img-top img-fluid p-2"
                style={{ width: "100%", height: "280px" }}
              />
              <div className="card-body p-4">
                <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  kryzen insect net
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center py-5 px-3 mt-7">
          <motion.h1
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.7 }}
            className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
          >
            🌿 Structure Comparison Table
          </motion.h1>

          <hr></hr>
        </div>
        <div
          className="p-4 shadow rounded"
          style={{
            background:
              "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
            color: "#000",
            border: "1px solid #c0e6b6",
            borderRadius: "8px",
            padding: "1rem",
          }}
        >
          <div className="table-responsive">
            <table className="table table-bordered table-striped align-middle">
              <thead className="table-success text-center">
                <tr>
                  <th>Features</th>
                  <th>Kryzen Structure</th>
                  <th>Others Structure</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, idx) => (
                  <tr key={idx}>
                    <td className="fw-semibold">{row.feature}</td>
                    <td>{row.kryzen}</td>
                    <td>{row.others}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
};

export default NaturallyVentilatedPolyhouse;
